import { useState } from "react";
import "./exercise.css";
import AdditionConfig from "../addition/AdditionConfig";
import MultiplicationConfig from "../multiplication/MultiplicationConfig";
import DivisionConfig from "../division/DivisionConfig";

export default function ExerciseSelector({ onNext, onStartAddition, onStartMultiplication, onStartDivision }) {
  const [modalType, setModalType] = useState(null);

  //set default values for power exercise config
  const [digit, setDigit] = useState("Single");
  const [exerciseType, setExerciseType] = useState("Addition");
  const [time, setTime] = useState("1 Minute");
  const [selectedExercise, setSelectedExercise] = useState("power");

  //validation
  const isValid = digit && exerciseType && time;

  return (
    <div className="exercise">

      {/* Brain Stretches */}
      <div className="brain-pill">Brain Stretches</div>

      {/* Grid */}
      <div className="grid">

        <div
          className={`box ${selectedExercise === "power" ? "active" : "dashed"}`}
          onClick={() => setSelectedExercise("power")}
        >
          <div className="icon-circle left">
            <img src="/images/flash.svg" alt="Power" />
          </div>
          Power Exercise
        </div>

        <div
          className={`box ${selectedExercise === "addition" ? "active" : "dashed"}`}
          onClick={() => setSelectedExercise("addition")}
        >
          Addition
          <div className="icon-circle right">
            <img src="/images/plus.svg" alt="Addition" />
          </div>
        </div>

        <div
          className={`box ${selectedExercise === "multiplication" ? "active" : "dashed"}`}
          onClick={() => setSelectedExercise("multiplication")}
        >
          <div className="icon-circle left">
            <img src="/images/multiplication.svg" alt="Multiplication" />
          </div>
          Multiplication
        </div>

        <div
          className={`box ${selectedExercise === "division" ? "active" : "dashed"}`}
          onClick={() => setSelectedExercise("division")}
        >
          Division
          <div className="icon-circle right">
            <img src="/images/divide.svg" alt="Division" />
          </div>
        </div>

      </div>



{selectedExercise === "power" && (
  <div className="config-card">

    <div className="config-title">Power Exercise</div>

    <div className="row clickable" onClick={() => setModalType("digit")}>
      <span>Digit Size</span>
      <span>{digit || "Select"} ▼</span>
    </div>

    <div
      className="row clickable"
      onClick={() => setModalType("exercise")}
    >
      <span>Exercise type</span>
      <span>{exerciseType || "Select"} ▼</span>
    </div>

    <div className="row clickable" onClick={() => setModalType("time")}>
      <span>Time</span>
      <span>{time || "Select"} ▼</span>
    </div>

  </div>
)}

{selectedExercise === "addition" && (
  <AdditionConfig onStart={onStartAddition} />
)}

{selectedExercise === "multiplication" && (
  <MultiplicationConfig onStart={onStartMultiplication} />
)}

{selectedExercise === "division" && (
  <DivisionConfig onStart={onStartDivision} />
)}

      {/* Buttons */}
      {selectedExercise === "power" && (
        <div className="button-group">
          <button
            className="btn-primary"
            disabled={!isValid}
            onClick={() =>
              onNext({
                digit,
                exerciseType,
                time,
              })
            }
          >
            Next
          </button>
          </div>
      )}

      {/* MODAL */}
      {modalType && (
        <div className="modal-overlay">
          <div className="modal">

            {/* Header */}
            <div className="modal-header">
              {modalType === "digit" && (
                <>
                  <strong>Digit Size</strong>
                  <p>Option to select</p>
                </>
              )}

              {modalType === "exercise" && (
                <>
                  <strong>Method</strong>
                  <p>Option to select</p>
                </>
              )}

              {modalType === "time" && (
                <>
                  <strong>Select Time</strong>
                  <p>Option to select</p>
                </>
              )}
            </div>

            {/* OPTIONS */}
            <div className="modal-options">

              {/* DIGIT */}
              {modalType === "digit" && (
                <>
                  {["Single", "Double", "Triple"].map((item) => (
                    <div
                      key={item}
                      className={`option ${digit === item ? "selected" : ""}`}
                      onClick={() => {
                        setDigit(item);
                        setModalType(null);
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </>
              )}

              {/* EXERCISE TYPE */}
              {modalType === "exercise" && (
                <>
                  {["Addition", "Subtraction"].map((item) => (
                    <div
                      key={item}
                      className={`option ${
                        exerciseType === item ? "selected" : ""
                      }`}
                      onClick={() => {
                        setExerciseType(item);
                        setModalType(null);
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </>
              )}

              {/* TIME */}
              {modalType === "time" && (
                <>
                  {["1 Minute", "2 Minutes"].map((item) => (
                    <div
                      key={item}
                      className={`option ${time === item ? "selected" : ""}`}
                      onClick={() => {
                        setTime(item);
                        setModalType(null);
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </>
              )}

            </div>

            {/* Cancel */}
            <div className="cancel" onClick={() => setModalType(null)}>
              Cancel
            </div>

          </div>
        </div>
      )}

    </div>
  );
}